module.exports = __webpack_public_path__ + "img/under-maintenance.fa0197fe.gif";